export default __webpack_public_path__ + "static/media/logo-lg-2048w.2b240dff.webp";